module.exports = __webpack_public_path__ + "img/20200929_local_startup_experience_sharing.884f7d94.jpg";